// First import on purpose: migrates legacy localStorage keys before any module
// that reads them at import time gets evaluated.
import './lib/migrate.js';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { App } from './app.jsx';
import { queryClient } from './lib/api.js';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

// Deliberately not wrapped in <StrictMode>: its double-invoked effects would
// create, tear down and recreate the WebGL context and the game socket on every
// mount. The engine lives outside React's lifecycle anyway — see app.tsx.
createRoot(container).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
